import { render, staticRenderFns } from "./ApplicationFormView.vue?vue&type=template&id=60c21aa6"
import script from "./ApplicationFormView.vue?vue&type=script&lang=js"
export * from "./ApplicationFormView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports